<template>
  <div
    id="home"
    class="full-height"
  >
    <components :is="componentsName"/>
  </div>
</template>

<script>
import Vue from 'vue'

function insertAfter(newNode, targetNode) {
  targetNode.parentNode.insertBefore(newNode, targetNode.nextElementSibling)
}

export default {
  data() {
    return {
      componentsName: 'div'
    }
  },
  created() {
    if(!window['home-page']) {
      let head = document.head || document.getElementsByTagName('head')[0]
      let script = document.createElement('script')
      script.src = 'http://192.168.10.55:5501/public/homePage/home-page.umd.js'
      head.appendChild(script)

      let title = document.getElementsByTagName('title')[0]
      let link = document.createElement('link')
      link.href = 'http://192.168.10.55:5501/public/homePage/home-page.css'
      link.rel = 'stylesheet'
      link.type = 'text/css'
      insertAfter(link, title)

      script.onload = () => {
        Vue.component('home-page', window['home-page'])
        this.componentsName = 'home-page'
      }
    } else {
      this.componentsName = 'home-page'
    }
  }
}
</script>
